module.exports = __webpack_public_path__ + "static/media/googleplay_button_black@2x.ed9864fe.png";